/*
 * One pill and one Start/Pause button over two engines (design `54`, plan Phase 4 "Combined
 * controls"): the server's commands, the web pill and the Telegram confirm-pause all derive
 * availability from here, never from pools alone.
 */
/** Pools states the shared Pause applies to (the `pauseRun` guard accepts exactly these). */
export function poolsPausable(state) {
    return state === "running" || state === "limit" || state === "needs-attention";
}
/** A spot run Pause stops: starting or running (a red overlay keeps the lifecycle). */
export function spotPausable(spot) {
    return spot !== null && (spot.lifecycle === "starting" || spot.lifecycle === "running");
}
/**
 * The pools tone (design 47): red only while money is exposed and the run cannot manage it on
 * its own; a hold, a limit or stopping is amber; a healthy run is green.
 */
export function poolsTone(status) {
    if (status.hold)
        return "warn";
    switch (status.state) {
        case "off":
        case "paused":
            return "neutral";
        case "stopping":
        case "limit":
            return "warn";
        case "needs-attention":
            return status.cycles.length > 0 ? "bad" : "warn";
        case "running":
            return "good";
    }
}
/**
 * The spot tone (design 52): red only for money at risk (a sale that keeps failing, a key that
 * stopped working while coins are held); every other attention, a key hold and stopping are
 * amber; coins held is green; waiting in USDT, starting, paused and off are grey.
 */
export function spotTone(spot) {
    if (spot.state === "needs-attention")
        return spot.reason === "sale-failing" || spot.reason === "key-broken-holding" ? "bad" : "warn";
    if (spot.hold !== null && spot.lifecycle !== "off" && spot.lifecycle !== "paused")
        return "warn";
    switch (spot.lifecycle) {
        case "stopping":
            return "warn";
        case "running":
            return spot.running === "in-coins" ? "good" : "neutral";
        default:
            return "neutral";
    }
}
const RANK = { neutral: 0, good: 1, warn: 2, bad: 3 };
/** Grey ranks lowest, so one engine paused never hides the other one trading. */
export function worseTone(a, b) {
    return RANK[b] > RANK[a] ? b : a;
}
export function autopilotControls(input) {
    const { status, spot } = input;
    return {
        tone: spot ? worseTone(poolsTone(status), spotTone(spot)) : poolsTone(status),
        start: status.state === "off",
        pause: poolsPausable(status.state) || spotPausable(spot),
        resume: input.poolsResumable || (spot?.actions.resume.allowed ?? false),
        stopping: status.state === "stopping" || spot?.lifecycle === "stopping",
    };
}
